import { render, staticRenderFns } from "./Hesaplamalar.vue?vue&type=template&id=00c55211"
import script from "./Hesaplamalar.vue?vue&type=script&lang=ts"
export * from "./Hesaplamalar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports